import React, { useState } from 'react';

const CountDropdown = ({
  label = 'Items',
  items = [],
  renderItem,
  keyExtractor = (item, i) => i,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(prev => !prev);

  return (
    <div className={`cd-container ${className} app-dark-mode`}>
      <div className='cd-header' onClick={toggle}>
        <span>{label} ({items.length})</span>
        <span className={`cd-arrow ${isOpen ? 'open' : ''}`}>
          ▾
        </span>
      </div>

      {isOpen && (
        <div className='cd-list'>
          {items.length === 0 && (
            <div className='cd-empty'>No items</div>
          )}

          {items.map((item, index) => (
            <div key={keyExtractor(item, index)} className='cd-item'>
              {renderItem ? renderItem(item) : String(item)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountDropdown;